import { FC, useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import  './gift-texts.scss'

type FrameProps = {
    handleClose: () => void
    src: string
}
type VideoProps = {
    src: string
    title: string
}


const Frame: FC<FrameProps> = ({ src, handleClose }) => {
    const [isReady, setIsReady] = useState(false)
    useEffect((): () => void => {
        setIsReady(true)
        window.document.body.className = 'no-scroll'
        return () => window.document.body.className = ''
    }, [isReady])

    if (!isReady || typeof window === 'undefined') {
        return null
    }

    return createPortal(
        <div onClick={handleClose} className='portal'>
            <div className='frame-container'>
                <button tabIndex={-1} aria-hidden='true' type='button' onClick={handleClose} className='close-button'>
                    <Icon/>
                </button>
                <iframe
                    frameBorder='0'
                    title='XO'
                    className='frame'
                    src={src}
                    allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                />
            </div>

        </div>,
        window.document.body,
    )
}

const Video: FC<VideoProps> = ({ src, title }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <div className='frame-button'>
                <div className='icon-button' onClick={() => setIsOpen(true)}>
                    <Button />
                </div>
                <div onClick={() => setIsOpen(true)} className='video-title'>
                    {title}
                </div>
            </div>
            {isOpen ? <Frame src={src} handleClose={() => setIsOpen(false)} /> : null}
        </>
    )
}


const Button: FC = () => {
    return (

      <svg width="59" height="52" viewBox="0 0 59 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59" height="52" fill="#D8353B"/>
        <path d="M27 35V17L37 26L27 35Z" fill="white"/>
      </svg>

    );
}
const Icon: FC = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'>
            <rect
                width='29.168'
                height='1.945'
                x='1'
                y='21.625'
                fill='#fff'
                rx='0.972'
                transform='rotate(-45 1 21.625)'
            ></rect>
            <rect
                width='29.168'
                height='1.945'
                fill='#fff'
                rx='0.972'
                transform='scale(-1 1) rotate(-45 14.604 38.576)'
            ></rect>
        </svg>
    );
}


export default Video
